export const CATEGORY_ORDER = [
  "Schutz & Sicherheit",
  "Telefon & Empfang",
  "Event & Hostessen",
  "Personen & VIP",
  "Alarm & Intervention",
  "Technik & Überwachung",
  "Zusätzliche Leistungen",
];

export const DEFAULT_SITE_CONFIG = {
  brand: {
    name: "Deutsche Bewachung & Sicherheit",
    short_name: "Deutsche B&S",
    tagline: "Sicherheitslösungen mit Präsenz, Struktur und Verlässlichkeit.",
  },
  contact: {
    phone: "+49 177 695 7663",
    whatsapp: "+49 177 695 7663",
    email: "info@deutschebunds.de",
    address: "Kugelfangtrift 61a",
    city: "30657 Hannover, Niedersachsen",
  },
  services: [],
};

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_image-tracker-23/artifacts/1qz1y2ir_ChatGPT%20Image%2020.%20Apr.%202026%2C%2014_12_05.png";
export const SECONDARY_IMAGE = "https://customer-assets.emergentagent.com/job_image-tracker-23/artifacts/ilxkc4mv_ChatGPT%20Image%2020.%20Apr.%202026%2C%2013_36_22.png";

export const BENEFIT_PILLS = [
  "Hannover & Niedersachsen",
  "klare Einsatzstrukturen",
  "direkte Ansprechpartner",
  "Telefon, WhatsApp & E-Mail",
];

export const VALUE_ITEMS = [
  {
    title: "Präsenz mit Wirkung",
    text: "Sicherheitskräfte, die sichtbar, aufmerksam und serviceorientiert auftreten – passend zum Einsatzumfeld.",
  },
  {
    title: "Klare Prozesse",
    text: "Von der Anfrage bis zur Einsatzplanung setzen wir auf nachvollziehbare Abläufe, kurze Wege und saubere Kommunikation.",
  },
  {
    title: "Flexible Einsätze",
    text: "Von Empfang und Revierdienst bis Baustellenbewachung und VIP-Begleitung – abgestimmt auf Ihren Bedarf.",
  },
];

export const REFERENCE_SECTORS = [
  {
    title: "Baustellen & Infrastruktur",
    text: "Zugangskontrolle, Materialschutz und Präsenzdienste für sensible Bauabschnitte.",
  },
  {
    title: "Gewerbe & Büroobjekte",
    text: "Empfang, Revierdienst und strukturierte Sicherheitsroutinen für laufende Betriebsflächen.",
  },
  {
    title: "Industrie & Werksgelände",
    text: "Objekt- und Werkschutz mit klaren Prozessen, Kontrollpunkten und Meldestrukturen.",
  },
  {
    title: "Veranstaltungen & VIP",
    text: "Sicherheitsbegleitung, Zugangskontrolle und koordinierte Abläufe für Events und besondere Gäste.",
  },
  {
    title: "Wohnanlagen & Quartiere",
    text: "Patrouillen, Interventionsdienste und Sichtpräsenz für geordnete Objektumfelder.",
  },
  {
    title: "Empfang & Servicezonen",
    text: "Professioneller Erstkontakt mit Sicherheitsfokus für Unternehmen und Besucherbereiche.",
  },
];

export const WHY_US_POINTS = [
  "seriöses Auftreten und klare Kommunikation",
  "individuelle Einsatzplanung statt Standardlösung",
  "direkte Ansprechpartner für Auftraggeber",
  "schnelle Rückmeldung über Telefon, WhatsApp oder Formular",
];

export const PROCESS_STEPS = [
  {
    title: "1. Bedarf klären",
    text: "Sie schildern uns Objekt, Einsatzzeitraum und gewünschte Leistung – telefonisch, per WhatsApp oder Formular.",
  },
  {
    title: "2. Lösung abstimmen",
    text: "Wir strukturieren den Bedarf, definieren Umfang und legen einen realistischen, passenden Einsatzrahmen fest.",
  },
  {
    title: "3. Einsatz starten",
    text: "Mit klaren Ansprechpartnern, dokumentierten Abläufen und einem Auftritt, der Sicherheit und Seriosität vermittelt.",
  },
];
